import React from 'react'

export interface FormFunction {
  befSaveForm?: (formData: any, appFormSaveData: any) => boolean
  saveForm?: (formData: any, appFormSaveData: any) => boolean
  afterSaveForm?: (formData: any, appFormSaveData: any) => boolean
}



export interface AppGridContext {
  GridData?: any
  onChange?: () => void
  setCurrTabIndex?: (tabIndex: number) => void
  currTabIndex?: number
}
export const AppGridContext = React.createContext<AppGridContext>({} as AppGridContext)



// WEBPACK FOOTER //
// ./src/components/AppGridLayout/AppGridData.tsx